import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import useDesktop from '../../../../../../../hooks/useDesktop';
import ImageIcon from '../../../../../../../assets/icons/Image';
import EventIcon from '../../../../../../../assets/icons/Event';
import Paper from '../../../../../../../components/atomic/Paper';
import ActionList from '../../../../../../../components/ActionList';
import DocumentIcon from '../../../../../../../assets/icons/Document';
import { getRoomId, getRoomImages } from '../../../../../../../utils/rooms';
import { uploadImage as apiUploadImage } from '../../../../../../../api/rooms';
import UploadImageButton from '../../../../../../../components/forms/ImageForm/UploadImageButton';

const RoomActionsMenu = ({
  room,
  classes,
  onImagesUploaded,
  onEventIconClick,
  onDocumentIconClick,
}) => {
  const isDesktop = useDesktop();
  const [imageRef, setImageRef] = useState(null);

  const openImageUploadDialog = () => imageRef.click();

  const existingImages = getRoomImages(room);
  const lastImagePosition = Array.isArray(existingImages)
    ? existingImages.length
    : 0;

  const uploadImageRequest = (image, position) =>
    apiUploadImage(getRoomId(room), image, position);

  const actions = [
    {
      icon: DocumentIcon,
      text: 'Dokument',
      onClick: onDocumentIconClick,
    },
    {
      icon: ImageIcon,
      text: 'Bilde',
      onClick: openImageUploadDialog,
    },
    {
      icon: EventIcon,
      text: 'Hendelse',
      onClick: onEventIconClick,
    },
  ];

  return (
    <Paper visible={!isDesktop}>
      <strong className={classes.title}>LEGG TIL I ROMMET</strong>

      <UploadImageButton
        showButton={false}
        imageRef={imageRef}
        setImageRef={setImageRef}
        onImagesUploaded={onImagesUploaded}
        lastImagePosition={lastImagePosition}
        uploadImageRequest={uploadImageRequest}
      />

      <ActionList actions={actions} />
    </Paper>
  );
};

export default withStyles(styles)(RoomActionsMenu);
